<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.deliveries'), $t('text.list')]">
        <!-- <el-button
          v-if="Permit.canActionsChargeEdition('deliverAction')"
          type="default"
          size="mini"
          @click="$router.push('/normal/lms/deliveries/import-courier-cost')"
          >{{ $t("action.importCourierCost") }}</el-button
        > -->
        <el-button
          v-if="Permit.isChargeEdition() && Permit.canActions('deliverAction')"
          type="primary"
          size="mini"
          @click="$router.push('/normal/lms/deliveries/picking-check')"
          >{{ $t("action.pickingCheck") }}</el-button
        >
        <el-button
          v-if="Permit.isChargeEdition() && Permit.canActions('deliverAction')"
          type="success"
          size="mini"
          @click="$router.push('/normal/lms/deliveries/loop')"
        >
          {{ $t("action.loopDelivery") }}
        </el-button>
        <el-button
          v-if="
            Permit.canActionsChargeEdition('deliverAction') ||
            Permit.canActionsChargeEdition('deliverUploadTracking')
          "
          type="default"
          size="mini"
          @click="$router.push('/normal/lms/deliveries/import-tracking')"
          >{{ $t("action.importTracking") }}</el-button
        >

        <el-button
          type="default"
          size="mini"
          @click="$router.push('/normal/lms/scan-records')"
          >{{ $t("action.scanRecords") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <!-- <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('delivery.serialNoTracking')"
          />
        </el-form-item> -->
        <!-- <el-form-item>
          <el-select
            size="small"
            v-model.trim="searchForm.serialNos"
            clearable
            filterable
            remote
            multiple
            :loading="serialNosLoading"
            :remote-method="querySearchSerialNos"
            @change="handleSelectSerialNos"
            :placeholder="$t('delivery.serialNo')"
          >
            <el-option
              v-for="serialNo of serialNos"
              :key="serialNo"
              :label="serialNo"
              :value="serialNo"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model.trim="searchForm.trackings"
            clearable
            filterable
            remote
            multiple
            :loading="trackingsLoading"
            :remote-method="querySearchTrackings"
            @change="handleSelectTrackings"
            :placeholder="$t('delivery.tracking')"
          >
            <el-option
              v-for="tracking of trackings"
              :key="tracking"
              :label="tracking"
              :value="tracking"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.serialNo"
            :fetch-suggestions="querySearchSerialNo"
            :trigger-on-focus="false"
            style="width: 100%"
            clearable
            :placeholder="$t('delivery.serialNo')"
            @select="handleSelectSerialNo"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.tracking"
            :fetch-suggestions="querySearchTracking"
            :trigger-on-focus="false"
            style="width: 100%"
            clearable
            :placeholder="$t('delivery.tracking')"
            @select="handleSelectTracking"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.deliverMethodName"
            :placeholder="$t('placeholder.expressChannel')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.batchSerialNo"
            :placeholder="$t('delivery.batchSerialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.shopId"
            :placeholder="$t('menu.shops')"
            filterable
            clearable
          >
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.deliverId"
            :placeholder="$t('delivery.deliverBy')"
            filterable
            clearable
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
          />
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="deliverAt"
          ref="deliverAtRef"
          :start-placeholder="$t('rules.startAt', [$t('delivery.deliverAt')])"
          :end-placeholder="$t('rules.endAt', [$t('delivery.deliverAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="customerReceiveAt"
          :start-placeholder="
            $t('rules.startAt', [$t('dateTypes.customerReceiveAt')])
          "
          :end-placeholder="
            $t('rules.endAt', [$t('dateTypes.customerReceiveAt')])
          "
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="uploadAt"
          :start-placeholder="$t('rules.startAt', [$t('delivery.uploadAt')])"
          :end-placeholder="$t('rules.endAt', [$t('delivery.uploadAt')])"
        />

        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.customerCountry"
            filterable
            clearable
            :placeholder="$t('tenant.country')"
          >
            <el-option
              v-for="country in countries"
              :key="country"
              :label="$t('countries.' + country)"
              :value="country"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerProvince"
            :placeholder="$t('tenant.province')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div v-if="searchPromptDF" class="orange center font14 mgt10">
      发货单号和跟踪号搜索，默认搜索 发货日期
      是近三个月的，若查不到数据，请重新选择发货日期查询
    </div>

    <div class="wrapper table-area">
      <el-tabs
        v-model="activeName"
        type="card"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('tabs.oneMonth')" name="yes"></el-tab-pane>
        <el-tab-pane :label="$t('tabs.all')" name="no"></el-tab-pane>
      </el-tabs>
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown @command="selectFlag">
              <el-button type="default" size="mini">
                {{ $t("action.flag") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(flag, index) in flagsWithClear"
                  :key="index"
                  :command="flag"
                >
                  <flag :name="flag" />
                  {{ $t("flags." + flag) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}</el-dropdown-item
                >
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>

                <el-dropdown-item command="normal" divided>
                  {{ $t("action.downloadAddress") }}
                </el-dropdown-item>
                <el-dropdown-item command="DHLOrder" divided>
                  DHL运单
                </el-dropdown-item>
                <el-dropdown-item command="DHLBill"> DHL发票 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10 mgr10" @command="print">
              <el-button type="default" size="mini">
                {{ $t("action.print") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printDivA4">
                  {{ $t("action.printA4") }}{{ $t("tenant.address") }}
                </el-dropdown-item>
                <el-dropdown-item command="printDivTP">
                  {{ $t("action.pringTP") }}{{ $t("tenant.address") }}
                </el-dropdown-item>
                <el-dropdown-item command="printDivA4NoProductInfo">
                  {{ $t("action.printA4")
                  }}{{ $t("tenant.address") }}(无产品信息)
                </el-dropdown-item>
                <el-dropdown-item command="printDivTPNoProductInfo">
                  {{ $t("action.pringTP")
                  }}{{ $t("tenant.address") }}(无产品信息)
                </el-dropdown-item>
                <el-dropdown-item divided command="printDetailListDiv">
                  {{ $t("action.printDetailList") }}
                </el-dropdown-item>
                <el-dropdown-item command="printDetailListSimpleDiv">
                  {{ $t("action.printDetailList") }}(简捷)
                </el-dropdown-item>
                <el-dropdown-item command="printDetailListNoRemarkDiv">
                  {{ $t("action.printDetailList") }}(无备注)
                </el-dropdown-item>
                <el-dropdown-item divided command="printHandoverListDiv">
                  {{ $t("action.printHandoverList") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              type="default"
              size="mini"
              @click="print('printEOrderDiv')"
              >{{ $t("action.printEOrder") }}</el-button
            >

            <el-button
              v-if="
                Permit.isChargeEdition() &&
                (Permit.canActions('deliverAction') ||
                  Permit.canActions('deliverUploadTracking'))
              "
              type="warning"
              size="mini"
              @click="batchUploadTracking"
              >{{ $t("action.batchUploadTracking") }}</el-button
            >

            <el-button
              v-if="
                Permit.isChargeEdition() &&
                (Permit.canActions('deliverAction') ||
                  Permit.canActions('deliverUploadTracking'))
              "
              class="button-blue"
              size="mini"
              @click="batchAddTracking"
            >
              {{ $t("action.batchAddTracking") }}
            </el-button>

            <el-button type="info" size="mini" @click="batchAddRemark">{{
              $t("delivery.remark")
            }}</el-button>

            <el-button
              v-if="
                Permit.canActions('deliverAction') ||
                Permit.canActions('deliverUploadTracking')
              "
              type="success"
              size="mini"
              @click="refreshTracking"
              :loading="refreshTrackingDoing"
              >{{ $t("action.refreshTracking") }}</el-button
            >
            <el-button
              v-if="
                Permit.canActions('deliverAction') ||
                Permit.canActions('deliverUploadTracking')
              "
              type="primary"
              size="mini"
              @click="batchOnlineDeclaration"
              :loading="batchOnlineDeclarationDoing"
              >{{ $t("action.onlineDeclaration") }}</el-button
            >

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :loading="loading"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        id="deliveryTable"
        :span-method="mergeMethod"
        :row-class-name="calculateBgColor"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMergeLine">
              <thumbnail :images="row.images"></thumbnail>
            </span>
            <div v-else>
              <span class="float-left">
                <span v-if="row.flags != null && row.flags != ''">
                  <flag
                    v-for="flag of JSON.parse(row.flags).sort()"
                    :key="flag"
                    :name="flag"
                  />
                </span>
                <span class="blue mgr5" @click="showDelivery(row)">{{
                  row.serialNo
                }}</span>
                <span v-if="row.batchSerialNo != null" class="font10 mgl5">
                  {{ $t("delivery.batchSerialNoSimple") }}:
                  {{ row.batchSerialNo }}
                </span>
                <el-popover
                  v-if="row.checkAt != null"
                  placement="right"
                  width="300"
                  trigger="click"
                  class="mgr5"
                >
                  <div>
                    <div class="lineH24">
                      {{ $t("delivery.checkName") }}：{{ row.checkName }}
                    </div>
                    <div class="lineH24">
                      {{ $t("delivery.checkAt") }}：{{ row.checkAt }}
                    </div>
                  </div>
                  <span slot="reference" class="popover-reference green font10">
                    {{ $t("delivery.checked") }}
                  </span>
                </el-popover>
                <el-popover
                  v-if="row.weightAt != null"
                  placement="right"
                  width="300"
                  trigger="click"
                  class="mgr5"
                >
                  <div>
                    <div class="lineH24">
                      {{ $t("delivery.weightName") }}：{{ row.weightName }}
                    </div>
                    <div class="lineH24">
                      {{ $t("delivery.weightAt") }}：{{ row.weightAt }}
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="popover-reference orange font10"
                  >
                    {{ $t("delivery.weighted") }}({{ row.weight }}kg)
                  </span>
                </el-popover>
                <span
                  v-if="
                    (row.weight != null && row.weight != '') ||
                    (row.courierWeight != null && row.courierWeight != '')
                  "
                  class="font10 mgr5"
                >
                  {{ $t("delivery.weight") }}:{{ row.weight }}kg
                  <span
                    v-if="row.courierWeight != null && row.courierWeight != ''"
                  >
                    /{{ row.courierWeight }}kg
                  </span>
                </span>

                <el-popover
                  class="mgr5"
                  placement="right"
                  width="300"
                  trigger="click"
                >
                  <div>
                    <div v-if="row.deliverType == 'carry'" class="lineH24">
                      {{ $t("delivery.sender") }}：{{ row.sender }}
                    </div>
                    <span v-if="row.deliverType == 'express'">
                      <div class="lineH24">
                        {{ $t("delivery.express") }}：{{ row.express }}
                        <span v-if="row.eOrderType != null">
                          ({{ $t("eOrderTypes." + row.eOrderType) }})
                        </span>
                        /{{ row.deliverMethodName }}
                      </div>
                    </span>
                    <span v-if="row.deliverType == 'agent'">
                      <div class="lineH24">
                        {{ $t("delivery.agent") }}： {{ row.courierName }}/
                        {{ row.deliverMethodName }}
                      </div>
                    </span>
                    <div class="lineH24" v-if="row.tracking != null">
                      {{ $t("delivery.tracking") }}：{{ row.tracking }}
                    </div>
                    <div v-if="row.insured != null" class="lineH24">
                      {{ $t("delivery.insured") }}：{{ row.insured | currency }}
                    </div>
                    <div
                      v-if="row.deliverCost != null && row.deliverCost != ''"
                      class="lineH24"
                    >
                      {{ $t("delivery.deliverCost") }}:
                      {{ row.deliverCost | currency }}
                    </div>
                    <div
                      v-if="
                        row.extraCharge != null &&
                        row.extraCharge != '' &&
                        row.extraCharge != 0
                      "
                      class="lineH24"
                    >
                      {{ $t("order.extraCharge") }}:
                      {{ row.extraCharge | currency }}
                    </div>
                    <div
                      v-if="row.weight != null && row.weight != ''"
                      class="lineH24"
                    >
                      {{ $t("delivery.weight") }}：{{ row.weight }}kg
                    </div>
                    <div
                      v-if="
                        row.courierWeight != null && row.courierWeight != ''
                      "
                      class="lineH24"
                    >
                      {{ $t("delivery.courierWeight") }}：{{
                        row.courierWeight
                      }}kg
                    </div>

                    <div class="lineH24">
                      <span class="float-left">
                        {{ $t("bargain.deliveryRemark") }}：</span
                      >
                      <raw-html :content="row.remark" />
                    </div>
                  </div>
                  <span
                    v-if="row.deliverType != null"
                    slot="reference"
                    class="popover-reference"
                  >
                    {{ $t("deliverTypes." + row.deliverType) }}
                  </span>
                </el-popover>
                <span class="font10">
                  <span v-if="row.deliverType == 'carry' && row.sender != null">
                    ({{ row.sender }})
                  </span>
                  <span v-if="row.deliverType == 'express'">
                    ({{ row.express }}
                    <span v-if="row.eOrderType != null">
                      ({{ $t("eOrderTypes." + row.eOrderType) }})
                    </span>
                    /{{ row.deliverMethodName }}
                    )
                  </span>
                  <span v-if="row.deliverType == 'agent'">
                    ({{ row.courierName }}/
                    {{ row.deliverMethodName }}
                    )
                    <span v-if="row.declareAt != null" class="green"
                      >已申报</span
                    >
                    <span v-if="row.uploadAt != null" class="font8"
                      >{{ $t("delivery.uploadAt") }}:{{ row.uploadAt }}</span
                    >
                  </span>
                  <span v-if="row.tracking != null" class="mgl5">
                    {{ $t("delivery.tracking") }}:{{ row.tracking }}
                  </span>
                </span>

                <el-popover
                  v-if="row.fail == true"
                  class="mgr5"
                  placement="right"
                  width="600"
                  trigger="click"
                  @show="getFailInfos(row)"
                >
                  <vxe-table
                    :data="failInfos"
                    id="failInfosTable"
                    ref="failInfosTable"
                    class="recordsTable"
                    size="mini"
                    resizable
                    round
                    auto-resize
                    highlight-hover-row
                  >
                    <vxe-table-column
                      field="request"
                      :title="$t('requestResponse.request')"
                      min-width="200"
                    >
                      <template v-slot="{ row }">
                        <raw-html-limit-number
                          :content="row.request"
                          :number="80"
                          type="richText"
                        />
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="response"
                      :title="$t('requestResponse.response')"
                      min-width="400"
                    >
                      <template v-slot="{ row }">
                        <raw-html-limit-number
                          :content="row.response"
                          :number="80"
                          type="richText"
                        />
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                  <span
                    slot="reference"
                    class="popover-reference orange font10"
                  >
                    <i class="el-icon-warning-outline orange"></i>发货异常
                  </span>
                </el-popover>

                <span v-if="row.settle == true" class="font10 green mgl5">
                  {{ $t("delivery.settled") }}
                </span>
                <span
                  v-if="row.mCourierCostItemVerifyAt != null"
                  class="font10 green mgl5"
                >
                  {{ $t("delivery.mCourierCostItemVerifyAt") }}:{{
                    row.mCourierCostItemVerifyAt
                  }}
                </span>
              </span>
              <span class="float-right font10">
                <el-popover placement="right" width="300" trigger="click">
                  <div>
                    <div class="lineH24">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                      {{ row.customerPhone }}
                      <span v-if="row.customerCountry != null">{{
                        $t("countries." + row.customerCountry)
                      }}</span>
                      {{ row.customerProvince }} {{ row.customerCity }}
                      {{ row.customerAddress }} {{ row.customerZipcode }}
                    </div>
                  </div>
                  <span slot="reference" class="popover-reference">
                    {{ $t("menu.customers") }}: {{ row.customerName
                    }}<span v-if="row.customerCountry != null">
                      ({{ $t("countries." + row.customerCountry) }})</span
                    >
                  </span>
                </el-popover>

                <span class="mgl5"
                  >{{ row.deliverBy }} {{ row.deliverAt }}</span
                >
                <thumbnail-text
                  class="mgl5"
                  v-if="row.attachment != null"
                  :srcs="row.attachment"
                  :text="$t('product.attachment')"
                />
                <span v-if="row.printAt != null" class="mgl5">
                  {{ $t("order.printAt") }}: {{ row.printAt }}
                </span>
                <span v-if="row.receiveAt != null" class="mgl5 font8">
                  {{ $t("returnBack.receiveAt") }}: {{ row.receiveAt }}
                </span>
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
            <div
              v-if="row.innerSerialNo != null && row.innerSerialNo != ''"
              class="font8"
            >
              {{ row.innerSerialNo }}
            </div>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
              <span class="mgl10 font10">{{ row.shopName }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.categoryName }}</div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="presentReceiveQuantity"
          :title="$t('order.currentDeliverQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.presentDeliverQuantity }}{{ row.unit }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="24"
              type="richText"
            />
            <div
              v-if="row.specJson != null && row.specJson != '[]'"
              class="font10"
            >
              <el-popover placement="right" width="100" trigger="click">
                <div>
                  <div
                    v-for="(specJson, specIndex) of JSON.parse(row.specJson)"
                    :key="specIndex"
                    class="lineH24"
                  >
                    {{ specJson.name }}：{{ specJson.value }}
                  </div>
                </div>
                <span slot="reference" class="popover-reference">
                  {{ $t("product.specJson") }}
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealRemark"
          :title="$t('order.dealRemark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.dealRemark" :number="20" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerReceiveAt"
          :title="$t('dateTypes.customerReceiveAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="130"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <template v-if="row.isMergeLine">
              <i
                slot="reference"
                class="el-icon-edit fl"
                @click="editRemark(row, rowIndex)"
              />
              <raw-html-limit-number
                :content="row.remark"
                :number="3"
                style="font-size: 8px"
              />
              <el-dropdown>
                <a class="el-dropdown-link small-link">
                  {{ $t("text.more") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="font10" @click="editAttachment(row, rowIndex)">
                      {{ $t("text.edit") }}{{ $t("product.attachment") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (row.deliverType == 'express' ||
                        row.deliverType == 'agent') &&
                      row.tracking == null
                    "
                  >
                    <div class="font10" @click="selfDelivery(row, rowIndex)">
                      {{ $t("action.selfDelivery") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.settle != true && row.settlementId == null"
                  >
                    <div class="font10" @click="signSettle(row, rowIndex)">
                      {{ $t("action.signSettle") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="row.settle == true">
                    <div class="font10" @click="signSettle(row, rowIndex)">
                      {{ $t("action.cancelSignSettle") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="Permit.canActions('deliverAction')">
                    <div class="font10" @click="retrieve(row, rowIndex)">
                      {{ $t("action.retrieve") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      ['express', 'agent'].includes(row.deliverType) &&
                      row.tracking != null &&
                      Permit.canActions('deliverAction')
                    "
                  >
                    <div class="font10" @click="change(row, rowIndex)">
                      {{ $t("action.change") }}
                    </div>
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="
                      row.retrieveAt != null &&
                      Permit.canActions('deliverAction')
                    "
                  >
                    <div class="font10" @click="editAddress(row, rowIndex)">
                      {{ $t("action.editAddress") }}
                    </div>
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="
                      Permit.isChargeEdition() &&
                      Permit.canActions('deliverAction') &&
                      row.tracking == null &&
                      ['agent', 'express'].includes(row.deliverType)
                    "
                  >
                    <div class="font10" @click="addTracking(row, rowIndex)">
                      {{ $t("action.addTracking") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      Permit.isChargeEdition() &&
                      row.courierName &&
                      row.courierName.indexOf('联邦') !== -1
                    "
                  >
                    <div class="font10" @click="printInvoice(row, rowIndex)">
                      {{ $t("action.printInvoice") }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div>
                <el-dropdown
                  v-if="
                    row.retrieveAt != null && Permit.canActions('deliverAction')
                  "
                >
                  <el-button type="text" size="mini">
                    {{ $t("action.reDelivery") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      command="agent"
                      v-if="Permit.extendModels().includes('lmsC')"
                    >
                      <div class="font10" @click="reDeliver(row, 'agent')">
                        {{ $t("deliverTypes.agent") }}
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="express"
                      v-if="Permit.extendModels().includes('lmsE')"
                    >
                      <div class="font10" @click="reDeliver(row, 'express')">
                        {{ $t("deliverTypes.express") }}
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item command="express">
                      <div class="font10" @click="reDeliver(row, 'carry')">
                        {{ $t("deliverTypes.carry") }}
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item command="take">
                      <div class="font10" @click="reDeliver(row, 'take')">
                        {{ $t("deliverTypes.take") }}
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item command="take">
                      <div
                        class="font10"
                        @click="reDeliver(row, 'signDeliver')"
                      >
                        {{ $t("deliverTypes.signDeliver") }}
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button
                  type="text"
                  size="mini"
                  @click="sellerShip(row)"
                  v-if="
                    ['agent'].includes(row.deliverType) &&
                    ['速卖通', '速卖通无忧'].includes(row.courierName) &&
                    row.aliexpressShipAt == null
                  "
                >
                  {{ $t("action.sellerShip") }}
                </el-button>

                <el-button
                  v-if="
                    row.courierName == 'DHL公司' &&
                    row.tracking != null &&
                    row.declareAt == null
                  "
                  type="text"
                  size="mini"
                  @click="onlineDeclaration(row)"
                >
                  {{ $t("action.onlineDeclaration") }}
                </el-button>
              </div>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 打印1 -->
    <div id="printDivA4" style="display: none">
      <div
        v-for="(item, itemIndex) in selectRecords"
        :key="item.id"
        :style="fourPageBreakStyle(itemIndex)"
      >
        <table
          style="
            width: 300;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              {{ Permit.currentTenant().name }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.serialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.serialNo }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.express") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.deliverType == 'express'">
                {{ item.express }}
              </span>
              <span v-if="item.deliverType == 'agent'">
                {{ item.courierName }}/{{ item.deliverMethodName }}
              </span>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.tracking") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.tracking }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.weight") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.weight }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerName") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerName }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerPhone }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.country") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.customerCountry != null">
                {{ $t("countries." + item.customerCountry) }}
              </span>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.province") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerProvince }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.city") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerCity }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("customer.zipcode") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerZipcode }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.address") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerAddress }}
            </td>
          </tr>
          <tr
            style="border: 1px solid #dfe5ec"
            v-if="item.remark != null && item.remark != ''"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.deliveryRemark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.remark }}
            </td>
          </tr>
          <tr
            v-if="printInnerSerialNo(item) != null"
            style="border: 1px solid #dfe5ec"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("order.innerSerialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ printInnerSerialNo(item) }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <input v-model="item.remark" style="border: none" />
            </td>
          </tr>
          <tr
            v-if="item.tracking != null"
            style="border: 1px solid #dfe5ec; text-align: center"
          >
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.tracking" height="40px"></barcode>
            </td>
          </tr>

          <tr
            v-for="order of item.orders"
            :key="order.id"
            style="border: 1px solid #dfe5ec"
          >
            <td style="width: 75px; border: 1px solid #dfe5ec">
              <img :src="order.firstImage" width="34px" />
            </td>
            <td style="width: 75px; border: 1px solid #dfe5ec">
              <p>
                {{ order.productNo }}&nbsp;&nbsp;{{ order.color }}&nbsp;&nbsp;{{
                  order.size
                }}&nbsp;&nbsp;{{ order.presentDeliverQuantity }}{{ order.unit }}
              </p>
            </td>
          </tr>

          <tr v-if="item.goodsName != null && item.goodsName != ''">
            <td style="border: 1px solid #dfe5ec" colspan="2">
              <span style="margin-right: 5px">
                {{ item.goodsName }}
              </span>
              <span
                v-if="item.goodsNameEn != null && item.goodsNameEn != ''"
                style="margin-right: 5px"
              >
                {{ item.goodsNameEn }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="printDivTP" style="display: none">
      <div
        v-for="(item, itemIndex) in selectRecords"
        :key="item.id"
        :style="itemIndex == 0 ? '' : 'page-break-before: always;'"
      >
        <table
          style="
            width: 300;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              {{ Permit.currentTenant().name }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.serialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.serialNo }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.express") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.deliverType == 'express'">{{
                item.express
              }}</span>
              <span v-if="item.deliverType == 'agent'"
                >{{ item.courierName }}/{{ item.deliverMethodName }}</span
              >
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.tracking") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.tracking }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.weight") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.weight }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerName") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerName }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerPhone }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.country") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.customerCountry != null">{{
                $t("countries." + item.customerCountry)
              }}</span
              >{{ item.customerProvince }}{{ item.customerCity }}
            </td>
          </tr>

          <!-- <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.province") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerProvince }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.city") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerCity }}
            </td>
          </tr> -->
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("customer.zipcode") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerZipcode }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.address") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerAddress }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td
              style="border: 1px solid #dfe5ec; width: 96px; text-align: center"
              colspan="2"
            >
              <qrcode
                :value="`${item.serialNo}`"
                :options="{ width: 100 }"
                :tag="'img'"
              />
            </td>
          </tr>
          <tr
            style="border: 1px solid #dfe5ec"
            v-if="item.remark != null && item.remark != ''"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.deliveryRemark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.remark }}
            </td>
          </tr>
          <tr
            v-if="printInnerSerialNo(item) != null"
            style="border: 1px solid #dfe5ec"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("order.innerSerialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ printInnerSerialNo(item) }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <input v-model="item.remark" style="border: none" />
            </td>
          </tr>
          <tr
            v-if="item.tracking != null"
            style="border: 1px solid #dfe5ec; text-align: center"
          >
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.tracking" height="40px"></barcode>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="width: 75px; border: 1px solid #dfe5ec">
              {{ $t("order.productInfo") }}
            </td>
            <td style="width: 75px; border: 1px solid #dfe5ec">
              <p v-for="order of item.orders" :key="order.id">
                {{ order.productNo }}&nbsp;&nbsp;{{ order.color }}&nbsp;&nbsp;{{
                  order.size
                }}&nbsp;&nbsp;{{ order.presentDeliverQuantity }}{{ order.unit }}
              </p>
            </td>
          </tr>

          <tr v-if="item.goodsName != null && item.goodsName != ''">
            <td style="border: 1px solid #dfe5ec" colspan="2">
              <span style="margin-right: 5px">
                {{ item.goodsName }}
              </span>
              <span
                v-if="item.goodsNameEn != null && item.goodsNameEn != ''"
                style="margin-right: 5px"
              >
                {{ item.goodsNameEn }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="printDivA4NoProductInfo" style="display: none">
      <div
        v-for="(item, itemIndex) in selectRecords"
        :key="item.id"
        :style="fourPageBreakStyle(itemIndex)"
      >
        <table
          style="
            width: 300;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              {{ Permit.currentTenant().name }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.serialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.serialNo }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.express") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.deliverType == 'express'">{{
                item.express
              }}</span>
              <span v-if="item.deliverType == 'agent'"
                >{{ item.courierName }}/{{ item.deliverMethodName }}</span
              >
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.tracking") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.tracking }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.weight") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.weight }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerName") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerName }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerPhone }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.country") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.customerCountry != null">{{
                $t("countries." + item.customerCountry)
              }}</span>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.province") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerProvince }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.city") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerCity }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("customer.zipcode") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerZipcode }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.address") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerAddress }}
            </td>
          </tr>
          <tr
            style="border: 1px solid #dfe5ec"
            v-if="item.remark != null && item.remark != ''"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.deliveryRemark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.remark }}
            </td>
          </tr>
          <tr
            v-if="printInnerSerialNo(item) != null"
            style="border: 1px solid #dfe5ec"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("order.innerSerialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ printInnerSerialNo(item) }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <input v-model="item.remark" style="border: none" />
            </td>
          </tr>
          <tr
            v-if="item.tracking != null"
            style="border: 1px solid #dfe5ec; text-align: center"
          >
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.tracking" height="40px"></barcode>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid #dfe5ec" colspan="2">
              <span v-if="item.goodsName != null && item.goodsName != ''">
                <span style="margin-right: 5px">
                  {{ item.goodsName }}
                </span>
                <span
                  v-if="item.goodsNameEn != null && item.goodsNameEn != ''"
                  style="margin-right: 5px"
                >
                  {{ item.goodsNameEn }}
                </span>
              </span>
              {{ $t($t("text.quantity")) }}：{{
                printComputeQuantity(item.orders)
              }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="printDivTPNoProductInfo" style="display: none">
      <div
        v-for="(item, itemIndex) in selectRecords"
        :key="item.id"
        :style="itemIndex == 0 ? '' : 'page-break-before: always;'"
      >
        <table
          style="
            width: 300;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              {{ Permit.currentTenant().name }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.serialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.serialNo }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.express") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.deliverType == 'express'">{{
                item.express
              }}</span>
              <span v-if="item.deliverType == 'agent'"
                >{{ item.courierName }}/{{ item.deliverMethodName }}</span
              >
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.tracking") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.tracking }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("delivery.weight") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.weight }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerName") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerName }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerPhone }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.country") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <span v-if="item.customerCountry != null">{{
                $t("countries." + item.customerCountry)
              }}</span>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.province") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerProvince }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.city") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerCity }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("customer.zipcode") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerZipcode }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("tenant.address") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.customerAddress }}
            </td>
          </tr>
          <tr
            style="border: 1px solid #dfe5ec"
            v-if="item.remark != null && item.remark != ''"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("bargain.deliveryRemark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ item.remark }}
            </td>
          </tr>
          <tr
            v-if="printInnerSerialNo(item) != null"
            style="border: 1px solid #dfe5ec"
          >
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("order.innerSerialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              {{ printInnerSerialNo(item) }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 96px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 200px">
              <input v-model="item.remark" style="border: none" />
            </td>
          </tr>
          <tr
            v-if="item.tracking != null"
            style="border: 1px solid #dfe5ec; text-align: center"
          >
            <td style="width: 75px; border: 1px solid #dfe5ec" colspan="2">
              <barcode :value="item.tracking" height="40px"></barcode>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid #dfe5ec" colspan="2">
              <span v-if="item.goodsName != null && item.goodsName != ''">
                <span style="margin-right: 5px">
                  {{ item.goodsName }}
                </span>
                <span
                  v-if="item.goodsNameEn != null && item.goodsNameEn != ''"
                  style="margin-right: 5px"
                >
                  {{ item.goodsNameEn }}
                </span>
              </span>
              {{ $t($t("text.quantity")) }}：{{
                printComputeQuantity(item.orders)
              }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="printHandoverListDiv" style="display: none">
      <div style="text-align: center">
        <strong>发货交接清单（{{ Util.formatDate(new Date()) }}）</strong>
      </div>
      <div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: center;
          "
        >
          <tr>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("delivery.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("tenant.country") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              <strong>{{ $t("delivery.weight") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5e">
              <strong>发货路线</strong>
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              <strong>{{ $t("order.giveAt") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("delivery.tracking") }}</strong>
            </td>
          </tr>
          <tr v-for="(cr, index) in selectRecords" :key="index">
            <td style="border: 1px solid #dfe5ec">{{ cr.serialNo }}</td>
            <td style="border: 1px solid #dfe5ec">
              <span v-if="cr.customerCountry != null">{{
                $t("countries." + cr.customerCountry)
              }}</span>
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.weight }}</td>
            <td style="border: 1px solid #dfe5ec">
              <span
                v-if="cr.deliverType != null && cr.deliverType != 'agent'"
                >{{ $t("deliverTypes." + cr.deliverType) }}</span
              >
              <span v-if="cr.deliverType == 'agent'">{{
                cr.deliverMethodName
              }}</span>
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.deliverAt }}</td>
            <td style="border: 1px solid #dfe5ec">{{ cr.tracking }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div id="printDetailListDiv" style="display: none">
      <div style="text-align: center">
        <strong>发货清单（{{ Util.formatDate(new Date()) }}）</strong>
      </div>
      <div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: center;
          "
        >
          <tr>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.qrcode") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("order.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.color") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.size") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.category") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("order.deliverQuantity") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.remark") }}</strong>
            </td>
          </tr>
          <tbody v-for="(cr, index) in selectRecords" :key="index">
            <tr v-for="(order, orderIndex) in cr.orders" :key="orderIndex">
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  v-if="order.serialNo != null"
                  :value="order.serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
                <!-- :value="`${order.productNo}|${order.color}||${order.size}|order|${order.serialNo}`" -->
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img
                  v-if="order.firstImage"
                  style="width: 80px"
                  :src="order.firstImage"
                  width="100%"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 120px">
                {{ order.serialNo }}
              </td>
              <td style="border: 1px solid #dfe5ec">{{ order.productNo }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.color }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.size }}</td>
              <td style="border: 1px solid #dfe5ec">
                {{ order.categoryName }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ order.presentDeliverQuantity }}{{ order.unit || "" }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                <raw-html :content="order.remark"></raw-html>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="printDetailListNoRemarkDiv" style="display: none">
      <div style="text-align: center">
        <strong>发货清单（{{ Util.formatDate(new Date()) }}）</strong>
      </div>
      <div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: center;
          "
        >
          <tr>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.qrcode") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("order.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.color") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.size") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.category") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("order.deliverQuantity") }}</strong>
            </td>
          </tr>
          <tbody v-for="(cr, index) in selectRecords" :key="index">
            <tr v-for="(order, orderIndex) in cr.orders" :key="orderIndex">
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  v-if="order.serialNo != null"
                  :value="order.serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
                <!-- :value="`${order.productNo}|${order.color}||${order.size}|order|${order.serialNo}`" -->
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img
                  v-if="order.firstImage"
                  style="width: 80px"
                  :src="order.firstImage"
                  width="100%"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 120px">
                {{ order.serialNo }}
              </td>
              <td style="border: 1px solid #dfe5ec">{{ order.productNo }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.color }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.size }}</td>
              <td style="border: 1px solid #dfe5ec">
                {{ order.categoryName }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ order.presentDeliverQuantity }}{{ order.unit || "" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="printDetailListSimpleDiv" style="display: none">
      <div style="text-align: center">
        <strong>发货清单（{{ Util.formatDate(new Date()) }}）</strong>
      </div>
      <div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: center;
          "
        >
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 180px">
              <strong>{{ $t("order.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.color") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.size") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("order.deliverQuantity") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.remark") }}</strong>
            </td>
          </tr>
          <tbody v-for="(cr, index) in selectRecords" :key="index">
            <tr v-for="(order, orderIndex) in cr.orders" :key="orderIndex">
              <td style="border: 1px solid #dfe5ec">{{ order.serialNo }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.productNo }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.color }}</td>
              <td style="border: 1px solid #dfe5ec">{{ order.size }}</td>
              <td style="border: 1px solid #dfe5ec">
                {{ order.presentDeliverQuantity }}{{ order.unit || "" }}
              </td>
              <td style="border: 1px solid #dfe5ec; text-align: left">
                <raw-html :content="order.remark"></raw-html>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 批量添加跟踪号 -->
    <el-dialog
      :title="$t('action.addTracking')"
      :close-on-click-modal="false"
      :visible.sync="batchAddTrackingDF"
      width="30%"
    >
      <el-form ref="batchAddTrackingForm" :model="batchAddTrackingObj">
        <el-form-item
          :prop="'tracking'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.tracking')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="batchAddTrackingObj.tracking"
            :placeholder="$t('delivery.tracking')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="batchAddTrackingDoing"
          size="small"
          @click="batchAddTrackingSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchAddTrackingDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑备注 -->
    <el-dialog
      :title="$t('text.remark')"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          v-model="editRemarkObj.remark"
          size="small"
          type="textarea"
          :autosize="{ minRows: 6 }"
          class="mb10"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 自发货 -->
    <el-dialog
      :title="$t('action.selfDelivery')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editForm" :model="editObj" label-width="80px">
        <el-form-item
          :label="$t('delivery.tracking')"
          :prop="'tracking'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.tracking')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model="editObj.tracking" />
        </el-form-item>
        <el-form-item :label="$t('delivery.weight')" :prop="'weight'">
          <el-input size="small" v-model="editObj.weight" />
        </el-form-item>
        <el-form-item :label="$t('delivery.deliverCost')" :prop="'deliverCost'">
          <el-input size="small" v-model="editObj.deliverCost" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editDoing"
          size="small"
          @click="selfDeliverySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑附件 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editAttachmentDF"
      width="30%"
    >
      <el-form
        ref="editAttachmentObjForm"
        :model="editAttachmentObj"
        label-width="50px"
      >
        <el-form-item :label="$t('product.attachment')" :prop="'deliverCost'">
          <dropzone v-model="editAttachmentObj.attachment" multiple></dropzone>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editAttachmentSubmitDoing"
          size="small"
          @click="editAttachmentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editAttachmentDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <drawer
      :title="$t('text.view', [$t('menu.deliveries')])"
      :visible.sync="showDeliveryDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowDeliveryId" />
    </drawer>
    <!-- 转单信息-->
    <el-dialog
      :title="$t('action.change')"
      :close-on-click-modal="false"
      :visible.sync="changeDF"
      width="30%"
    >
      <el-form ref="changeObjForm" :model="changeObj" label-width="80px">
        <el-form-item
          :prop="'tracking'"
          :label="$t('delivery.changeTracking')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.changeTracking')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="changeObj.tracking"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="changeDoing"
          size="small"
          @click="changeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="changeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑地址 -->
    <el-dialog
      :title="$t('action.editAddress')"
      :visible.sync="editAddressDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="editAddressForm" :model="editAddressObj" label-width="60px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="$t('user.name')"
              :prop="'customerName'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('user.name')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('user.phone')"
              :prop="'customerPhone'"
              label-width="90px"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('user.name')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerPhone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('tenant.country')">
              <el-select
                size="small"
                v-model.trim="editAddressObj.customerCountry"
                filterable
              >
                <el-option
                  v-for="country in countries"
                  :key="country"
                  :label="$t('countries.' + country)"
                  :value="country"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="$t('tenant.province')"
              :prop="'customerProvince'"
            >
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerProvince"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('tenant.city')" :prop="'customerCity'">
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerCity"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('customer.zipcode')"
              :prop="'customerAddress'"
            >
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerZipcode"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="$t('tenant.address')"
              :prop="'customerAddress'"
            >
              <el-input
                size="small"
                v-model.trim="editAddressObj.customerAddress"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('shop.iossNum')" :prop="'iossNum'">
              <el-input size="small" v-model.trim="editAddressObj.iossNum" />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="$t('shop.iossCountryCode')"
              :prop="'iossCountryCode'"
              label-width="88px"
            >
              <el-select
                size="small"
                v-model="editAddressObj.iossCountryCode"
                filterable
                clearable
              >
                <el-option
                  v-for="country in countries"
                  :key="country"
                  :label="$t('countries.' + country)"
                  :value="country"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editAddressSubmitDoing"
          size="small"
          @click="editAddressSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editAddressDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 重发 -->
    <el-dialog
      :title="$t('action.reDelivery')"
      :close-on-click-modal="false"
      :visible.sync="reDeliverDF"
      width="50%"
    >
      <el-form ref="reDeliverForm" :model="reDeliverObj" label-width="90px">
        <span v-if="reDeliverObj.deliverType == 'agent'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.couriers')"
                :prop="'courierId'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.couriers')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model.trim="reDeliverObj.courierId"
                  clearable
                  filterable
                  @change="selectCourier"
                >
                  <el-option
                    v-for="(c, cIndex) in couriers"
                    :key="cIndex"
                    :label="c.courier.name"
                    :value="c.courier.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('courier.channel')"
                :prop="'courierId'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('courier.channel')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model.trim="reDeliverObj.deliverMethodId"
                >
                  <el-option
                    v-for="(deliverMethod, dIndex) in deliverMethods"
                    :key="dIndex"
                    :label="deliverMethod.name"
                    :value="deliverMethod.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.goodsName')"
                :prop="'goodsName'"
              >
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.goodsName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.goodsNameEn')"
                :prop="'goodsNameEn'"
              >
                <el-input
                  size="small"
                  v-model="reDeliverObj.goodsNameEn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.weight')" :prop="'weight'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.weight"
                  placeholder="kg"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.insured')" :prop="'insured'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.insured"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('shop.iossNum')" :prop="'iossNum'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.iossNum"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('shop.iossCountryCode')"
                :prop="'iossCountryCode'"
              >
                <el-select
                  size="small"
                  v-model="reDeliverObj.iossCountryCode"
                  filterable
                  clearable
                  :placeholder="$t('shop.iossCountryCode')"
                >
                  <el-option
                    v-for="country in countries"
                    :key="country"
                    :label="$t('countries.' + country)"
                    :value="country"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.hsCode')" :prop="'hsCode'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.hsCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.toPay')" :prop="'toPay'">
                <el-checkbox
                  size="small"
                  v-model.trim="reDeliverObj.toPay"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </span>
        <span v-if="reDeliverObj.deliverType == 'express'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.expresses')"
                :prop="'_expressTenantId'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.expresses')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model.trim="reDeliverObj._expressTenantId"
                  clearable
                  filterable
                  @change="selectExpressTenant"
                >
                  <el-option
                    v-for="(expressTenant, eIndex) in expressTenants"
                    :key="eIndex"
                    :label="expressTenant.text"
                    :value="expressTenant.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.deliveryMethode')"
                :prop="'deliverMethodId'"
              >
                <el-select
                  size="small"
                  v-model.trim="reDeliverObj.deliverMethodId"
                >
                  <el-option
                    v-for="(deliverMethod, dIndex) in deliverMethods"
                    :key="dIndex"
                    :label="deliverMethod.name"
                    :value="deliverMethod.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.tracking')" :prop="'tracking'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.tracking"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.deliverCost')"
                :prop="'insured'"
              >
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.deliverCost"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.weight')" :prop="'weight'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.weight"
                  placeholder="kg"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.insured')" :prop="'insured'">
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.insured"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.deliveryType')"
                :prop="'toPay'"
              >
                <el-radio-group
                  size="small"
                  v-model.trim="reDeliverObj.transType"
                >
                  <el-radio-button :label="1">陆运</el-radio-button>
                  <el-radio-button :label="2">空运</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.toPay')" :prop="'toPay'">
                <el-checkbox
                  size="small"
                  v-model.trim="reDeliverObj.toPay"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </span>
        <span v-if="reDeliverObj.deliverType == 'carry'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.sender')"
                :prop="'sender'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('delivery.sender')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.sender"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('delivery.deliverCost')"
                :prop="'insured'"
              >
                <el-input
                  size="small"
                  v-model.trim="reDeliverObj.deliverCost"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('delivery.toPay')" :prop="'toPay'">
                <el-checkbox
                  size="small"
                  v-model.trim="reDeliverObj.toPay"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="reDeliverDoing"
          size="small"
          @click="reDeliverSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="reDeliverDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 标记结算 -->
    <el-dialog
      :title="$t('action.reDelivery')"
      :close-on-click-modal="false"
      :visible.sync="signSettleDF"
      width="30%"
    >
      <el-form
        ref="signSettleObjForm"
        :model="signSettleObj"
        label-width="80px"
      >
        <el-form-item :label="'结算费用'" :prop="'courierCost'">
          <el-input
            size="small"
            v-model.trim="signSettleObj.courierCost"
            placeholder="kg"
          ></el-input>
        </el-form-item>
        <el-form-item :label="'结算重量'" :prop="'courierWeight'">
          <el-input
            size="small"
            v-model.trim="signSettleObj.courierWeight"
            placeholder="kg"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="signSettleSubmitDoing"
          size="small"
          @click="signSettleSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="signSettleDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 发货通知 -->
    <el-dialog
      :title="$t('action.sellerShip')"
      :visible.sync="sellerShipDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="sellerShipObjForm"
        :model="sellerShipObj"
        label-width="80px"
      >
        <el-form-item
          :label="$t('delivery.serviceName')"
          :prop="'serviceName'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.serviceName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="sellerShipObj.serviceName"
            filterable
          >
            <el-option
              v-for="(sellerShip, index) in sellerShips"
              :key="index"
              :label="sellerShip.displayName"
              :value="sellerShip.serviceName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="sellerShipObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="sellerShipSubmitDoing"
          size="small"
          @click="sellerShipSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="sellerShipDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 在线申报 -->
    <el-dialog
      :title="$t('action.onlineDeclaration')"
      :visible.sync="onlineDeclarationDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="onlineDeclarationObjForm"
        :model="onlineDeclarationObj"
        label-width="110px"
      >
        <el-form-item
          :label="$t('courier.tradeName')"
          :prop="'tradeName'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.tradeName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="onlineDeclarationObj.tradeName"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('courier.tradeCoScc')"
          :prop="'tradeCoScc'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.tradeCoScc')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="onlineDeclarationObj.tradeCoScc"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('courier.tradeCode')" :prop="'tradeCode'">
          <el-input
            size="small"
            v-model.trim="onlineDeclarationObj.tradeCode"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="onlineDeclarationSubmitDoing"
          size="small"
          @click="onlineDeclarationSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="onlineDeclarationDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { table, page } from "@/utils/mixins.js";
import Util from "@/utils";
import {
  countries,
  flagsWithClear,
  flagsWithNone,
  sellerShips,
} from "@/utils/enums";
import Barcode from "vue-barcode";
import Qrcode from "@chenfengyuan/vue-qrcode";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import ThumbnailText from "@/components/ThumbnailText";
import DateRange from "@/components/DateRange";
import PagerConfig from "@/config/pager.js";

import Delivery from "@/api/delivery.js";
import Express from "@/api/express.js";
import Courier from "@/api/courier.js";
import Order from "@/api/order.js";
import CouriersRequestResponse from "@/api/couriersRequestResponse.js";
import Shop from "@/api/shop.js";
import User from "@/api/user.js";

import Show from "./show";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtml,
    Barcode,
    Qrcode,
    Dropzone,
    ThumbnailText,
    Show,
    DateRange,
  },
  data() {
    return {
      Util: Util,
      searchPromptDF: false,
      searchForm: {
        // keyword: null,
        // serialNos: [],
        // trackings: [],
        serialNo: null,
        tracking: null,
        deliverMethodName: null,
        batchSerialNo: null,
        productNo: null,
        color: null,
        customerName: null,
        handle: null,
        deliverAtStartAt: null,
        deliverAtEndAt: null,
        deliverAtSelectDF: false,
        customerReceiveAtStartAt: null,
        customerReceiveAtEndAt: null,
        shopId: null,
        customerCountry: null,
        customerProvince: null,
        latelyMonth: "yes",
        deliverId: null,
        uploadAtStartAt: null,
        uploadAtEndAt: null,
      },
      serialNos: [],
      trackings: [],
      serialNosLoading: false,
      sorter: {
        sortBy: "deliveries_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "deliveries_productNo",
      },
      flagsWithClear: flagsWithClear,
      flagsWithNone: flagsWithNone,
      narrows: [
        [
          {
            label: this.$t("delivery.deliveryType"),
            items: Delivery.deliverTypes.map((s) => {
              return {
                key: s,
                label: this.$t("deliverTypes." + s),
                condition: { deliverType: s },
              };
            }),
          },
          {
            label: this.$t("text.printInfo"),
            items: [
              {
                label: this.$t("printInfos.yes"),
                key: "printYes",
                condition: { print: "yes" },
              },
              {
                label: this.$t("printInfos.no"),
                key: "printNo",
                condition: { print: "no" },
              },
            ],
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("purchase.settleCheckInfo"),
            items: [
              {
                label: this.$t("settleCheckInfo.yes"),
                key: "mCourierCostVerifyYes",
                condition: { mCourierCostVerify: "yes" },
              },
              {
                label: this.$t("settleCheckInfo.no"),
                key: "mCourierCostVerifyNo",
                condition: { mCourierCostVerify: "no" },
              },
            ],
          },
          {
            label: this.$t("delivery.settle"),
            items: [
              {
                label: this.$t("signSettleInfos.yes"),
                key: "settleYes",
                condition: { manualSettle: "yes" },
              },
              {
                label: this.$t("signSettleInfos.no"),
                key: "settleNo",
                condition: { manualSettle: "no" },
              },
            ],
          },
          {
            label: this.$t("receive.receiveInfo"),
            items: [
              {
                label: this.$t("receiveInfos.yes"),
                key: "receiveYes",
                condition: { receive: "yes" },
              },
              {
                label: this.$t("receiveInfos.no"),
                key: "receiveNo",
                condition: { receive: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: Order.states_delivery.map((s) => {
              return {
                key: s,
                label: this.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
          {
            label: "在线申报",
            items: [
              {
                label: "已申报",
                key: "declareYes",
                condition: { declare: "yes" },
              },
              {
                label: "未申报",
                key: "declareNo",
                condition: { declare: "no" },
              },
            ],
          },
          {
            label: "上传跟踪号情况",
            items: [
              {
                label: "已上传",
                key: "uploadYes",
                condition: { upload: "yes" },
              },
              {
                label: "未上传",
                key: "uploadNo",
                condition: { upload: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("action.retrive"),
                key: "retriveYes",
                condition: { retrieve: "yes" },
              },
              {
                label: "发货异常",
                key: "failYes",
                condition: { fail: "yes" },
              },
            ],
          },
        ],
      ],
      suppliers: [],
      //
      currentRowIdx: null,
      currentRowId: null,
      currentRow: null,
      // 批量添加跟踪号
      batchAddTrackingType: "batch",
      batchAddTrackingDF: false,
      batchAddTrackingObj: {
        ids: [],
        tracking: null,
      },
      batchAddTrackingDoing: false,
      // 编辑备注
      currentRowIdx: null,
      addRemarkType: "batch",
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        id: null,
      },
      editRemarkDoing: false,
      // 编辑/自行发货
      row: null,
      editDF: false,
      editObj: {
        tracking: null,
        weight: null,
        deliverCost: null,
      },
      editDoing: false,
      // 编辑附件
      editAttachmentDF: false,
      editAttachmentObj: {
        attachment: null,
      },
      editAttachmentSubmitDoing: false,
      //
      currentRowDeliveryId: null,
      showDeliveryDF: null,
      // 转单
      changeDF: false,
      changeObj: {
        tracking: null,
      },
      changeDoing: false,
      // 编辑地址
      countries: countries,
      editAddressDF: false,
      editAddressObj: {
        customerName: null,
        customerPhone: null,
        customerCountry: null,
        customerProvince: null,
        customerCity: null,
        customerAddress: null,
        customerZipcode: null,
        iossNum: null,
        iossCountryCode: null,
      },
      editAddressSubmitDoing: false,
      // 重发
      reDeliverDF: false,
      reDeliverObj: {
        id: null,
        deliverType: null,
        // express
        tracking: null,
        goodsName: null,
        goodsNameEn: null,
        hsCode: null,
        iossNum: null,
        iossCountryCode: null,
        deliverCost: null,
        weight: null,
        insured: null,
        transType: null, // 1陆运2空运
        _expressTenantId: null,
        express: null,
        expressId: null,

        courierId: null,
        courierName: null,
        deliverMethodId: null,
        deliverMethodName: null,
        _selectedExpressCode: null,
        printTemplate: false,
        toPay: false,
        //
        sender: null,
      },
      couriers: [],
      deliverMethods: [],
      expressTenants: [],
      shops: [],
      users: [],
      reDeliverDoing: false,
      //标记结算
      row: null,
      rowIndex: null,
      signSettleDF: false,
      signSettleObj: {
        settle: false,
        courierCost: null,
        courierWeight: null,
      },
      signSettleSubmitDoing: false,
      //发货通知
      sellerShips: sellerShips,
      sellerShipDF: false,
      sellerShipObj: {
        servieName: null,
        remark: null,
      },
      sellerShipSubmitDoing: false,
      //
      refreshTrackingDoing: false,
      //
      failInfos: [],
      batchOnlineDeclarationDoing: false,
      //在线申报
      row: null,
      onlineDeclarationDF: false,
      onlineDeclarationObj: {
        tradeName: null,
        tradeCoScc: null,
        tradeCode: null,
      },
      onlineDeclarationSubmitDoing: false,
      activeName: "yes",
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, shops) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
    if (self.Permit.extendModels().includes("lmsC")) {
      Courier.findCourierTenantByTenantId().then(function (res) {
        if (res.status === 200) {
          self.couriers = res.data;
          self.narrows.push([
            {
              label: self.$t("menu.couriers"),
              items: self.couriers.map((r) => {
                return {
                  label: r.courier && r.courier.name,
                  key: r.id,
                  condition: { courierId: r.courierId },
                };
              }),
            },
          ]);
        } else {
          self.sysError();
        }
      });
    }
    if (self.Permit.extendModels().includes("lmsE")) {
      self.expressTenants = [];
      Express.findByTenantId().then(function (res) {
        if (res.status === 200) {
          const expressTenants = res.data;
          if (expressTenants.length !== 0) {
            for (const e of expressTenants) {
              if (e.expressId != null) {
                e.text = e.name + "(可打面单)";
              } else {
                e.text = e.name;
              }
              self.expressTenants.push(e);
            }
            self.narrows.push([
              {
                label: self.$t("menu.expresses"),
                items: self.expressTenants.map((r) => {
                  return {
                    label: r.name,
                    key: r.id,
                    condition: { expressId: r.expressId },
                  };
                }),
              },
            ]);
          }
        } else {
          self.sysError();
        }
      });
    }
    // 打印面单做连接用
    this.doConnect();
  },

  methods: {
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Delivery.vagueFindSerialNo({ serialNo: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        self.serialNos = ps.map((p) => {
          return { value: p };
        });
        cb(self.serialNos);
      });
    },
    handleSelectSerialNo() {},
    querySearchTracking(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Delivery.vagueFindTracking({ tracking: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        self.trackings = ps.map((p) => {
          return { value: p };
        });
        cb(self.trackings);
      });
    },
    handleSelectTracking() {},

    // querySearchSerialNos(queryString, cb) {
    //   const self = this;
    //   if (queryString == null || queryString.length < 1) {
    //     return;
    //   }
    //   this.serialNosLoading = true;
    //   Delivery.vagueFindSerialNo({ serialNo: queryString }).then(function (
    //     res
    //   ) {
    //     self.serialNos = res.data;
    //     self.serialNosLoading = false;
    //   });
    // },

    // handleSelectSerialNos() {},

    // querySearchTrackings(queryString, cb) {
    //   const self = this;
    //   if (queryString == null || queryString.length < 1) {
    //     return;
    //   }
    //   this.trackingsLoading = true;
    //   Delivery.vagueFindTracking({ tracking: queryString }).then(function (
    //     res
    //   ) {
    //     self.trackings = res.data;
    //     self.trackingsLoading = false;
    //   });
    // },

    // handleSelectTrackings() {},

    handleClick(tab, event) {
      this.searchForm.latelyMonth = this.activeName;
      this.loadData();
    },
    narrowSelect(filters) {
      this.activeName = "no";
      this.searchForm.latelyMonth = this.activeName;
      this.pager.currentPage = 1;
      this.pager.pageSize = PagerConfig.normal.defaultPageSize;
      this.filters = filters;
      this.loadData();
    },
    search() {
      this.activeName = "no";
      this.searchForm.latelyMonth = this.activeName;
      this.pager.currentPage = 1;
      this.pager.pageSize = PagerConfig.normal.defaultPageSize;
      this.searchPromptDF = false;
      // console.log(
      //   "======this.searchForm:",
      //   (this.searchForm.serialNo ?? "") != "" ||
      //     (this.searchForm.tracking ?? "") != "",
      //   "===",
      //   this.searchForm.deliverAtSelectDF
      // );
      if (this.searchForm.deliverAtSelectDF == true) {
        // console.log("yes++++手动选择发货日期不用处理",);
        //手动选择发货日期不用处理
      } else {
        if (
          (this.searchForm.serialNo ?? "") != "" ||
          (this.searchForm.tracking ?? "") != ""
        ) {
          // console.log("no+++++++++没有选择");
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          this.searchForm.deliverAtStartAt = Util.formatDateTime(start);
          this.searchForm.deliverAtEndAt = Util.formatDateTime(end);
          this.searchPromptDF = true;
        } else {
          this.searchForm.deliverAtStartAt = null;
          this.searchForm.deliverAtEndAt = null;
        }
      }

      this.loadData();
    },
    getFailInfos(row) {
      const self = this;
      CouriersRequestResponse.findByDeliverySerialNo({
        deliverySerialNo: row.serialNo,
      }).then(function (res) {
        if (res.status == 200) {
          self.failInfos = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // getCouriers() {
    //   const self = this;
    //   Courier.findCourierTenantByTenantId().then(function (res) {
    //     if (res.status === 200) {
    //       self.couriers = res.data;
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
    // getExpresses() {
    //   const self = this;
    //   self.expressTenants = [];
    //   Express.findByTenantId().then(function (res) {
    //     if (res.status === 200) {
    //       const expressTenants = res.data;
    //       if (expressTenants.length !== 0) {
    //         for (const e of expressTenants) {
    //           if (e.expressId != null) {
    //             e.text = e.name + "(可打面单)";
    //           } else {
    //             e.text = e.name;
    //           }
    //           self.expressTenants.push(e);
    //         }
    //       }
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
    showDelivery(row) {
      this.currentRowDeliveryId = row.id;
      this.showDeliveryDF = true;
    },

    //DHL在线申报
    batchOnlineDeclaration() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const selectRecordsFilter = this.selectRecords.filter(
        (c) =>
          c.courierName == "DHL公司" &&
          c.tracking != null &&
          c.declareAt == null
      );
      if (selectRecordsFilter.length === 0) {
        this.$message.error(
          this.$t("prompt.atLeastOneDataCanOnlineDeclaration")
        );
        return;
      }
      let data = selectRecordsFilter.map((r) => {
        return { id: r.id };
      });
      self.batchOnlineDeclarationDoing = true;
      Delivery.batchOnlineDeclaration(data).then(function (res) {
        self.batchOnlineDeclarationDoing = false;
        self.onlineDeclarationDF = false;
        if (res.status == 200) {
          if (res.data.type == "fail") {
            self.$message({
              message: res.data.message,
              type: "warning",
            });
          } else {
            self.$message({
              message: res.data.message,
              type: "warning",
            });
            // self.$message({
            //   message: self.$t("prompt.onlineDeclarationSuccess"),
            //   type: "success",
            // });
          }
        } else {
          self.sysError();
        }
      });
    },

    refreshTracking() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const selectRecordsFilter = this.selectRecords
        .filter((c) => c.deliverType == "agent")
        .map((c) => c.id);
      if (selectRecordsFilter.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneDataAgent"));
        return;
      }
      self.refreshTrackingDoing = true;
      Delivery.refreshTracking(self.selectRecords.map((s) => s.id)).then(
        function (res) {
          self.refreshTrackingDoing = false;
          if (res.status == 200) {
            self.$message({
              message: self.$t("prompt.asynchronousAction"),
              type: "warning",
            });
          } else {
            self.sysError();
          }
        }
      );
    },
    //打印发票
    printInvoice(row) {
      const self = this;
      Delivery.printInvoice(row.id).then(function (res) {
        if (res.status == 200 && res.data.type == "success") {
          window.open(res.data.data);
        } else {
          self.sysError();
        }
      });
    },
    //DHL在线申报
    onlineDeclaration(row) {
      const self = this;
      Delivery.onlineDeclaration(row.id, {}).then(function (res) {
        self.onlineDeclarationSubmitDoing = false;
        self.onlineDeclarationDF = false;
        self.setLocalStorage(self.onlineDeclarationObj);
        if (res.status == 200) {
          if (res.data.type == "fail") {
            self.$message({
              message: res.data.message,
              type: "warning",
            });
          } else {
            self.$message({
              message: self.$t("prompt.onlineDeclarationSuccess"),
              type: "success",
            });
            self.loadData();
          }
        } else {
          self.sysError();
        }
      });
      // self.row = row;
      // self.onlineDeclarationObj.tradeName = self.getLocalStorage("tradeName");
      // self.onlineDeclarationObj.tradeCoScc = self.getLocalStorage("tradeCoScc");
      // self.onlineDeclarationObj.tradeCode = self.getLocalStorage("tradeCode");
      // self.onlineDeclarationSubmitDoing = false;
      // self.onlineDeclarationDF = true;
    },
    getLocalStorage(name) {
      let value = localStorage.getItem(name);
      if (
        value != null &&
        value != "null" &&
        value != undefined &&
        value != ""
      ) {
        return value;
      }
      return null;
    },
    setLocalStorage(obj) {
      localStorage.setItem("tradeName", obj.tradeName);
      localStorage.setItem("tradeCoScc", obj.tradeCoScc);
      localStorage.setItem("tradeCode", obj.tradeCode);
    },
    onlineDeclarationSubmit() {
      const self = this;
      self.$refs.onlineDeclarationObjForm.validate((valid) => {
        if (valid) {
          self.onlineDeclarationSubmitDoing = true;
          Delivery.onlineDeclaration(
            self.row.id,
            self.onlineDeclarationObj
          ).then(function (res) {
            self.onlineDeclarationSubmitDoing = false;
            self.onlineDeclarationDF = false;
            self.setLocalStorage(self.onlineDeclarationObj);
            if (res.status == 200) {
              self.$message({
                message: self.$t("prompt.onlineDeclarationSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 发货通知
    sellerShip(row) {
      const self = this;
      self.row = row;
      self.sellerShipObj.servieName = null;
      self.sellerShipObj.remark = null;
      self.sellerShipSubmitDoing = false;
      self.sellerShipDF = true;
    },
    sellerShipSubmit() {
      const self = this;
      self.$refs.sellerShipObjForm.validate((valid) => {
        if (valid) {
          self.sellerShipSubmitDoing = true;
          Delivery.sellerShip(self.row.id, self.sellerShipObj).then(function (
            res
          ) {
            self.sellerShipSubmitDoing = false;
            self.sellerShipDF = false;
            if (res.status == 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "warning",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重发
    reDeliver(row, type) {
      const self = this;
      self.row = row;
      self.reDeliverObj.id = row.id;
      self.reDeliverObj.deliverType = type;
      self.reDeliverObj.tracking = row.tracking;
      self.reDeliverObj.goodsName = row.goodsName;
      self.reDeliverObj.goodsNameEn = row.goodsNameEn;
      self.reDeliverObj.hsCode = row.hsCode;
      self.reDeliverObj.iossNum = row.iossNum;
      self.reDeliverObj.iossCountryCode = row.iossCountryCode;
      self.reDeliverObj.deliverCost = row.deliverCost;
      self.reDeliverObj.weight = row.weight;
      self.reDeliverObj.insured = row.insured;
      self.reDeliverObj.transType = row.transType;
      self.reDeliverObj._expressTenantId = null;
      self.reDeliverObj.express = null;
      self.reDeliverObj.expressId = null;
      self.reDeliverObj.courierId = null;
      self.reDeliverObj.courierName = null;
      self.reDeliverObj.deliverMethodId = null;
      self.reDeliverObj.deliverMethodName = null;
      self.reDeliverObj.printTemplate = false;
      self.reDeliverObj.toPay = false;
      self.reDeliverObj.sender = null;
      if (self.reDeliverObj.deliverType === "agent") {
        // self.getCouriers();
        self.reDeliverDoing = false;
        self.reDeliverDF = true;
      }
      if (self.reDeliverObj.deliverType === "express") {
        self.reDeliverObj.transType = "1";
        // self.getExpresses();
        self.reDeliverDoing = false;
        self.reDeliverDF = true;
      }
      if (self.reDeliverObj.deliverType == "carry") {
        self.reDeliverObj.sender = self.Permit.currentUser().name;
        self.reDeliverDoing = false;
        self.reDeliverDF = true;
      }
      if (["take", "signDeliver"].includes(self.reDeliverObj.deliverType)) {
        Delivery.reDeliver(self.reDeliverObj).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.reDeliverySuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    selectExpressTenant() {
      const self = this;
      const selectedExpressTenant = self.expressTenants.find(
        (e) => e.id === self.reDeliverObj._expressTenantId
      );
      self.reDeliverObj.express = selectedExpressTenant.name;
      self.reDeliverObj.expressId = selectedExpressTenant.expressId;

      if (self.reDeliverObj.expressId != null) {
        self.reDeliverObj._selectedExpressCode =
          selectedExpressTenant.express.code;
        self.deliverMethods = selectedExpressTenant.express.deliverMethods;
      }
    },
    selectCourier() {
      const self = this;
      self.reDeliverObj.deliverMethodId = null;
      self.reDeliverObj.deliverMethodName = null;

      self.reDeliverObj.courierName = self.couriers.find(
        (c) => c.courier.id === self.reDeliverObj.courierId
      ).courier.name;
      self.deliverMethods = self.couriers.find(
        (c) => c.courier.id === self.reDeliverObj.courierId
      ).courier.deliverMethods;
    },
    reDeliverSubmit() {
      const self = this;
      this.$refs.reDeliverForm.validate((valid) => {
        if (valid) {
          if (
            ["agent", "express"].includes(self.reDeliverObj.deliverType) &&
            self.deliverMethods.find(
              (d) => d.id === self.reDeliverObj.deliverMethodId
            ) != null
          ) {
            self.reDeliverObj.deliverMethodName = self.deliverMethods.find(
              (d) => d.id === self.reDeliverObj.deliverMethodId
            ).name;
          }
          self.reDeliverDoing = true;
          Delivery.reDeliver(self.reDeliverObj).then(function (res) {
            if (res.status === 200) {
              self.reDeliverDoing = false;
              self.reDeliverDF = false;
              self.$message({
                message: self.$t("prompt.reDeliverySuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑地址
    editAddress(row) {
      const self = this;
      self.row = row;
      self.editAddressObj.customerName = row.customerName;
      self.editAddressObj.customerPhone = row.customerPhone;
      self.editAddressObj.customerCountry = row.customerCountry;
      self.editAddressObj.customerProvince = row.customerProvince;
      self.editAddressObj.customerCity = row.customerCity;
      self.editAddressObj.customerAddress = row.customerAddress;
      self.editAddressObj.customerZipcode = row.customerZipcode;
      self.editAddressObj.iossNum = row.iossNum;
      self.editAddressObj.iossCountryCode = row.iossCountryCode;
      self.editAddressSubmitDoing = false;
      self.editAddressDF = true;
    },
    editAddressSubmit() {
      const self = this;
      this.$refs.editAddressForm.validate((valid) => {
        if (valid) {
          self.editAddressSubmitDoing = true;
          Delivery.updateCustomerInfo(self.row.id, self.editAddressObj).then(
            function (res) {
              self.editAddressSubmitDoing = false;
              self.editAddressDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 转单
    change(row) {
      const self = this;
      self.row = row;
      self.changeObj.tracking = null;
      self.changeDoing = false;

      self.changeDF = true;
    },
    changeSubmit() {
      const self = this;
      this.$refs.changeObjForm.validate((valid) => {
        if (valid) {
          self.changeDoing = true;
          Delivery.change(self.row.id, self.changeObj).then(function (res) {
            self.changeDoing = false;
            self.changeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.changeSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 撤单
    retrieve(row) {
      const self = this;
      Delivery.retrieve(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.retrieveSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 标记结算/取消标记结算
    signSettle(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.signSettleObj.settle = !row.settle;
      self.signSettleObj.courierCost = row.courierCost;
      self.signSettleObj.courierWeight = row.courierWeight;
      if (self.signSettleObj.settle == true) {
        if (["take", "signDeliver"].includes(row.deliverType)) {
          self.signSettleSubmit();
        } else {
          self.signSettleDF = true;
        }
      } else {
        self.signSettleSubmit();
      }
    },
    signSettleSubmit() {
      const self = this;
      self.signSettleSubmitDoing = true;
      Delivery.settle(self.row.id, self.signSettleObj).then(function (res) {
        self.signSettleSubmitDoing = false;
        self.signSettleDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.records[self.rowIndex].settle = !self.row.settle;
          self.records[self.rowIndex].courierCost =
            self.signSettleObj.courierCost;
          self.records[self.rowIndex].courierWeight =
            self.signSettleObj.courierWeight;
        } else {
          self.sysError();
        }
      });
    },
    // 编辑附件
    editAttachment(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editAttachmentObj.attachment = row.attachment;
      self.editAttachmentSubmitDoing = false;
      self.editAttachmentDF = true;
    },
    editAttachmentSubmit() {
      const self = this;
      self.editAttachmentDF = true;
      Delivery.updateAttachment(self.row.id, self.editAttachmentObj).then(
        function (res) {
          self.editAttachmentSubmitDoing = false;
          self.editAttachmentDF = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.records[self.currentRowIdx].attachment =
              self.editAttachmentObj.attachment;
          } else {
            self.sysError();
          }
        }
      );
    },
    // 自行发货/编辑
    selfDelivery(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.row = row;
      self.editDF = true;
      self.editObj.tracking = null;
      self.editObj.weight = row.weight;
      self.editObj.deliverCost = row.deliverCost;
    },
    selfDeliverySubmit() {
      const self = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Delivery.updateDeliverInfo(self.row.id, this.editObj).then(function (
            res
          ) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.selfDeliverySuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].tracking = self.editObj.tracking;
              self.records[self.currentRowIdx].weight = self.editObj.weight;
              self.records[self.currentRowIdx].deliverCost =
                self.editObj.deliverCost;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 标旗帜
    selectFlag(flag) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }

      const data = [];
      for (const c of self.selectRecords) {
        const obj = { id: c.id, flags: null };
        if (flag === "clear") {
          obj.flags = JSON.stringify([]);
        } else {
          const arr = c.flags != null ? JSON.parse(c.flags) : [];
          const newArr = arr.concat([flag]);
          obj.flags = JSON.stringify(newArr);
        }
        data.push(obj);
      }
      Delivery.updateFlags(data).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.signSuccess"),
            type: "success",
          });
          self.loadData();
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },
    // 添加备注
    batchAddRemark() {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.addRemarkType = "batch";
      self.editRemarkObj.remark = null;
      self.editRemarkDoing = false;
      self.editRemarkDF = true;
    },
    // 编辑备注
    editRemark(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.addRemarkType = "single";
      self.editRemarkObj.remark = row.remark;
      self.editRemarkObj.id = row.id;
      self.editRemarkDoing = false;
      self.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      this.editRemarkDoing = true;
      if (self.addRemarkType === "single") {
        Delivery.updateRemark(self.editRemarkObj).then(function (res) {
          self.editRemarkDoing = false;
          self.editRemarkDF = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.records[self.currentRowIdx].remark = self.editRemarkObj.remark;
          } else {
            self.sysError();
          }
        });
      } else {
        const data = self.selectRecords.map((c) => {
          return { id: c.id, remark: self.editRemarkObj.remark };
        });
        self.editRemarkDoing = true;
        Delivery.batchUpdateRemark(data).then(function (res) {
          self.editRemarkDoing = false;
          self.editRemarkDF = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.addSuccess"),
              type: "success",
            });
            for (const selectRecord of self.selectRecords) {
              selectRecord.remark = self.editRemarkObj.remark;
            }
          } else {
            self.sysError();
          }
        });
      }
    },
    // 上传跟踪号
    batchUploadTracking() {
      const self = this;
      const selectRecordsFilter = this.selectRecords.filter(
        (c) =>
          c.tracking != null &&
          c.deliverType !== "carry" &&
          c.deliverType !== "take"
      );
      if (selectRecordsFilter.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneTrackingData"));
        return;
      }
      if (confirm("半小时后到平台检查上传结果")) {
        Delivery.batchUploadTracking(selectRecordsFilter.map((c) => c.id)).then(
          function (res) {
            if (res.status === 200) {
              self.sysResults(
                res.data,
                self.$t("prompt.batchUploadTrackingSuccess")
              );
              // self.$message({
              //   message: self.$t("prompt.batchUploadTrackingSuccess"),
              //   type: "success",
              // });
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    // 批量添加跟踪号
    batchAddTracking() {
      this.batchAddTrackingType = "batch";
      const noTrackingDeliveries = this.selectRecords.filter(
        (c) =>
          c.tracking == null && ["agent", "express"].includes(c.deliverType)
      );
      if (noTrackingDeliveries.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneNoTrackingData"));
        return;
      }
      this.batchAddTrackingObj.ids = noTrackingDeliveries.map((d) => d.id);
      this.batchAddTrackingObj.tracking = null;
      this.batchAddTrackingDF = true;
    },
    addTracking(row, rowIndex) {
      this.batchAddTrackingType = "single";
      this.currentRowIdx = rowIndex;
      this.batchAddTrackingObj.ids = [row.id];
      this.batchAddTrackingObj.tracking = null;
      this.batchAddTrackingDF = true;
    },
    batchAddTrackingSubmit() {
      const self = this;
      this.$refs.batchAddTrackingForm.validate((valid) => {
        if (valid) {
          self.batchAddTrackingDoing = true;
          Delivery.batchVirtualDelivery(this.batchAddTrackingObj).then(
            function (res) {
              self.batchAddTrackingDoing = false;
              self.batchAddTrackingDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.addTrackingSuccess"),
                  type: "success",
                });
                if (self.batchAddTrackingType == "batch") {
                  for (const selectRecord of self.selectRecords) {
                    if (
                      selectRecord.tracking == null &&
                      !["carry", "take", "signDeliver"].includes(
                        selectRecord.deliverType
                      )
                    ) {
                      selectRecord.tracking = self.batchAddTrackingObj.tracking;
                    }
                  }
                } else {
                  self.records[self.currentRowIdx].tracking =
                    self.batchAddTrackingObj.tracking;
                }
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 下载地址
    downLoadAddress(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = {
        ids: this.selectRecords.map((c) => c.id),
      };
      if (type == "normal") {
        Delivery.exportExcelAddress(data).then(function (res) {
          if (res.data.code === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      }
      if (type == "DHLOrder") {
        Delivery.dhlOrderExportExcel(data).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      }
      if (type == "DHLBill") {
        Delivery.dhlBillExportExcel(data).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      }
    },
    // 下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: this.selectRecords.map((c) => c.id),
        };
        this.downloadData(data);
      }
      if (type === "search") {
        if ((JSON.stringify(self.conditions) === "{}") === true) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
      if (["normal", "DHLOrder", "DHLBill"].includes(type)) {
        self.downLoadAddress(type);
      }
    },
    downloadData(data) {
      const self = this;
      Delivery.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 打印
    print(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      // printDivA4
      // printDivTP
      // printDivA4NoProductInfo
      // printDivTPNoProductInfo
      // printDetailListDiv
      // printDetailListSimpleDiv
      // printDetailListNoRemarkDiv
      // printHandoverListDiv
      // printEOrderDiv printEOrderDiv
      if (type == "printEOrderDiv") {
        const deliverTypes = self.selectRecords.map((s) => s.deliverType);
        const deliverTypesSet = [...new Set(deliverTypes)];
        if (
          !(
            deliverTypesSet.length == 1 &&
            ["express", "agent"].includes(deliverTypesSet[0])
          )
        ) {
          self.$message({
            message: "只有发货方式为快递、货代的才可以打印面单，请选择其他打印",
            type: "warning",
          });
          return;
        }
        const trackings = self.selectRecords
          .map((s) => s.tracking)
          .filter((t) => t != null && t != "");
        if (trackings.length != self.selectRecords.length) {
          self.$message({
            message: "存在发货单的 跟踪号 不存在",
            type: "warning",
          });
          return;
        }

        if (deliverTypesSet[0] == "express") {
          // const deliverTypesExpress = self.selectRecords.filter(
          //   (c) => c.deliverType == "express"
          // );
          // if (deliverTypesExpress.length != self.selectRecords.length) {
          //   self.$message({
          //     message: "只有发货方式为快递的才可以打印面单，请选择其他打印",
          //     type: "warning",
          //   });
          //   return;
          // }
          const domesticExpressIds = self.selectRecords.map((c) => c.expressId);
          const domesticExpressIdsFilter = domesticExpressIds.filter(
            (id) => id != null
          );
          if (domesticExpressIdsFilter.length === 0) {
            this.$message.error(this.$t("prompt.atLeastOneDataExpress"));
            return;
          }
          const domesticExpressIdsSet = [...new Set(domesticExpressIds)];
          if (domesticExpressIdsSet.length !== 1) {
            this.$message.error(this.$t("prompt.differExpress"));
            return;
          }
        }
        if (deliverTypesSet[0] == "agent") {
          const agentIds = self.selectRecords.map((c) => c.courierId);
          const agentIdsFilter = agentIds.filter((id) => id != null);
          if (agentIdsFilter.length === 0) {
            this.$message.error(this.$t("prompt.atLeastOneDataAgent"));
            return;
          }
          const agentIdsSet = [...new Set(agentIdsFilter)];
          if (agentIdsSet.length !== 1) {
            this.$message.error(this.$t("prompt.differAgent"));
            return;
          }
          // 未申报的不能打印免单
          // if (self.selectRecords[0].courierName == "DHL公司") {
          //   let unDeclare = self.selectRecords.filter(
          //     (c) => c.declareAt == null
          //   );
          //   if(unDeclare.length != 0 ){
          //      this.$message.error('存在未申报的发货单');
          //   return;
          //   }
          // }

          // if (self.selectRecords[0].courierName == "华宇") {
          //   self.printFun("printDivTP");
          //   return;
          // }
        }
        const ids = this.selectRecords.map((c) => c.id);
        Delivery.batchPrintEOrders(ids).then(function (res) {
          if (res.status === 200) {
            const datas = res.data;
            if (datas.length === 0) {
              self.$message.error(self.$t("prompt.printErr"));
              return;
            }

            // 处理失败结果并提示
            const filterNullTemplates = datas.filter((r) => r.template == null);
            if (filterNullTemplates.length > 0) {
              const text =
                "总共" +
                ids.length +
                "条，失败" +
                filterNullTemplates.length +
                "条，失败原因:<br/><br/>";
              let detail = "";
              for (const data of datas) {
                detail =
                  detail +
                  "<div style='margin-bottom: 2px'>" +
                  data.reason +
                  "<div>";
              }
              self.$message({
                dangerouslyUseHTMLString: true,
                message: text + detail,
                type: "warning",
              });
              if (filterNullTemplates.length == datas.length) {
                return;
              }
            }
            //====货代
            if (deliverTypesSet[0] == "agent") {
              self.printFun2(datas[0].template);
              return;
            }
            //=======
            const documents = [];
            const successTemplates = datas.filter((r) => r.template != null);
            // 根不同的打印渠道，打印快递面大
            successTemplates.map((st) => {
              if (st.eOrderType === "KUAIDINIAO") {
                const style = Parse5.serialize(
                  Parse5.parse(res.data[0].template).childNodes[1].childNodes[1]
                );
                let bodys = "<head><style>" + style + "</style></head><body>";
                const printAddProductInfoCodes = ["SF"];
                const currentRow = self.selectRecords.filter(
                  (cr) => cr.id === st.id
                );
                if (printAddProductInfoCodes.includes(currentRow.express)) {
                  const doc = Parse5.parse(r.template);
                  const headBody = doc.childNodes[1];
                  const body = Parse5.serialize(headBody.childNodes[3]);
                  let productInfoTable =
                    "<table class='print_paper'><tr><td class='xx16'>货号</td><td class='xx16'>颜色</td><td class='xx16'>尺码</td><td class='xx16'>数量</td></tr>";
                  let productInfo = "";
                  for (const p of r.productInfos) {
                    const color = p.color || "无";
                    const size = p.size || "无";
                    productInfo =
                      productInfo +
                      "<tr><td>" +
                      p.productNo +
                      "</td><td>" +
                      color +
                      "</td><td>" +
                      size +
                      "</td><td>" +
                      p.quantity +
                      "</td></tr>";
                  }
                  productInfoTable =
                    productInfoTable + productInfo + "</table></div>";
                  bodys = bodys + body + productInfoTable;
                } else {
                  const doc = Parse5.parse(st.template);
                  const headBody = doc.childNodes[1];
                  const body = Parse5.serialize(headBody.childNodes[3]);
                  bodys = bodys + body;
                }
                // const newWindow = window.open("_blank");
                // newWindow.document.write(bodys + "</body>");
                // newWindow.document.close();
                const newWindow = window.open("", "_blank");
                const codestr = bodys + "</body>";
                newWindow.document.body.innerHTML = codestr;
              } else {
                // 淘宝菜鸟
                const obj = {
                  documentID: st.id,
                  contents: [
                    JSON.parse(st.template),
                    {
                      data: self.products4Second(st),
                      templateURL:
                        "http://cloudprint.cainiao.com/template/standard/357209/1",
                    },
                  ],
                };
                documents.push(obj);
              }
            });
            // 向菜鸟组件打印机发送指令
            if (documents.length > 0) {
              const request = {
                cmd: "print",
                requestID: Date.parse(new Date()),
                version: "1.0",
                task: {
                  taskID: self.getUUID(8, 10),
                  preview: false,
                  printer: "",
                  previewType: "pdf",
                  firstDocumentNumber: 10,
                  totalDocumentCount: 100,
                  documents: documents,
                },
              };
              self.socket.send(JSON.stringify(request));
            }
            if (successTemplates.length == 0) {
              return;
            }
            // 标记已打印
            Delivery.batchPrint(successTemplates.map((c) => c.id)).then(
              function (res) {
                if (res.status === 200) {
                  self.$message({
                    message: self.$t("prompt.printSuccess"),
                    type: "success",
                  });
                  self.loadData();
                } else {
                  self.sysError();
                }
              }
            );
          } else {
            self.sysError();
          }
        });
      } else {
        self.printFun(type);
      }
    },
    printInnerSerialNo(item) {
      if (item.length == 0) {
        return null;
      }
      let innerSerialNos = item.orders.map((c) => c.innerSerialNo);
      let innerSerialNosSet = [...new Set(innerSerialNos)];
      let innerSerialNosSetFilter = innerSerialNosSet.filter(
        (i) => i != null && i != ""
      );
      if (innerSerialNosSetFilter.length == 0) {
        return null;
      }
      return innerSerialNosSetFilter.join(";");
    },
    printEOrdeBase64Submit() {
      this.printEOrderBase64DF = false;
      this.printFun("printEOrderBase64Div");
    },
    printFun(type) {
      const self = this;
      Delivery.batchPrint(self.selectRecords.map((c) => c.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.printFunction(type);
          self.$message({
            message: self.$t("prompt.printSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    printFun2(openUrl) {
      const self = this;
      Delivery.batchPrint(self.selectRecords.map((c) => c.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          window.open(openUrl);
          self.$message({
            message: self.$t("prompt.printSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 打印面单做连接用
    doConnect() {
      const self = this;
      this.socket = new WebSocket("ws://localhost:13528");
      // 打开Socket
      self.socket.onopen = function (event) {
        // 监听消息
        self.socket.onmessage = function (event) {
          var printResult = JSON.parse(event.data);
          console.log(printResult);
          // layer.load();
          if (
            printResult.cmd === "print" &&
            (printResult.msg === "成功" || printResult.status === "success")
          ) {
            // 打印成功--做一些自己的处理
            console.log("连接成功！！！！！！！！");
          } else if (
            printResult.msg === "无效的打印机" ||
            printResult.status === "failed"
          ) {
            console.log("失败！！！！！！！！");
            // 打印失败--做一些自己的处理
          }
        };
        // 监听Socket的关闭
        self.socket.onclose = function (event) {
          console.log("Client notified socket has closed", event);
        };
      };
    },
    products4Second(result) {
      const obj = {
        productInfo: "",
        bargainSerialNo: result.bargainSerialNo,
        bargainRemark: result.bargainRemark,
      };
      if (result.productInfos.length !== 0) {
        let productInfoStr = "";
        for (const productInfo of result.productInfos) {
          productInfoStr = productInfoStr + productInfo.productNo;
          if (productInfo.color != null) {
            productInfoStr = productInfoStr + " " + productInfo.color;
          }
          if (productInfo.size != null) {
            productInfoStr = productInfoStr + " " + productInfo.size;
          }
          productInfoStr = productInfoStr + " " + productInfo.quantity + "件";
        }
        obj.productInfo = productInfoStr;
      }
      return obj;
    },
    getUUID(len, radix) {
      const chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
          ""
        );
      const uuid = [];
      const i = 0;
      radix = radix || chars.length;
      if (len) {
        for (let i = 0; i < len; i++) {
          uuid[i] = chars[0 | (Math.random() * radix)];
        }
      } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        for (let i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join("");
    },

    printComputeQuantity(orders) {
      let quantity = 0;
      for (const order of orders) {
        quantity = quantity + order.presentDeliverQuantity;
      }
      return quantity;
    },
    fourPageBreakStyle(index) {
      const basicStyle =
        "margin-bottom: 20px; display:inline-block; margin-right: 10px;";
      if (index !== 0 && ((index / 4) % 1 === 0) == true) {
        return basicStyle + "page-break-before: always;";
      } else {
        return basicStyle;
      }
    },
    //
    dataProvider(params) {
      return Delivery.search(params);
    },
    recordsDecorate(records) {
      this.records = this.buildTableData(records);
      this.mergeCells = this.buildMergeCells(records);
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        // let bOrder = {
        //   isMergeLine: true,
        //   id: record.id,
        //   serialNo: record.serialNo,
        //   deliverBy: record.deliverBy,
        //   ownerId: record.ownerId,
        //   ownerName: record.ownerName,

        //   deliverAt: record.deliverAt,
        //   deliverCost: record.deliverCost,
        //   deliverType: record.deliverType,
        //   express: record.express,
        //   tracking: record.tracking,
        //   remark: record.remark,
        //   receiveAt: record.receiveAt,
        //   receiveBy: record.receiveBy,
        //   sender: record.sender,
        //   senderId: record.senderId,
        //   receiverId: record.receiverId,
        //   quantity: record.quantity,
        //   purchaseId: record.purchaseId,
        //   courierId: record.courierId,
        //   weight: record.weight,
        //   insured: record.insured,
        //   verifyAt: record.verifyAt,
        //   customerName: record.customerName,
        //   customerPhone: record.customerPhone,
        //   customerCountry: record.customerCountry,
        //   customerProvince: record.customerProvince,
        //   customerCity: record.customerCity,
        //   customerAddress: record.customerAddress,
        //   customerZipcode: record.customerZipcode,
        //   courierName: record.courierName,
        //   deliverMethodId: record.deliverMethodId,
        //   deliverMethodName: record.deliverMethodName,
        //   explain: record.explain,
        //   courierWeight: record.courierWeight,
        //   deliveryCheckId: record.deliveryCheckId,
        //   toPay: record.toPay,
        //   expressId: record.expressId,
        //   transType: record.transType,
        //   printTemplate: record.printTemplate,
        //   innerSerialNo: record.innerSerialNo,
        //   settle: record.settle,
        //   settleAt: record.settleAt,
        //   mCourierCostItemVerifyAt: record.mCourierCostItemVerifyAt,
        //   retrieveAt: record.retrieveAt,
        //   printAt: record.printAt,
        //   deliveryItems: record.deliveryItems,
        //   deliveryType: record.deliveryType,
        //   settlementId: record.settlementId,
        //   courierCost: record.courierCost,
        //   expressTenantId: record.expressTenantId,
        //   eOrderType: record.eOrderType,
        //   deliverId: record.deliverId,
        //   receiveRemark: record.receiveRemark,
        //   batchSerialNo: record.batchSerialNo,
        //   goodsName: record.goodsName,
        //   goodsNameEn: record.goodsNameEn,
        //   hsCode: record.hsCode,
        //   size: record.size,
        //   changeSpecsQuantity: record.changeSpecsQuantity,
        //   confirmAt: record.confirmAt,
        //   confirmId: record.confirmId,
        //   confirmName: record.confirmName,
        //   attachment: record.attachment,
        //   extraCharge: record.extraCharge,
        //   workflowState: record.workflowState,
        //   lastPickId: record.lastPickId,
        //   lastPickName: record.lastPickName,
        //   lastPickAt: record.lastPickAt,
        //   checkId: record.checkId,
        //   checkName: record.checkName,
        //   checkAt: record.checkAt,
        //   weightId: record.weightId,
        //   weightName: record.weightName,
        //   weightAt: record.weightAt,
        //   eorderType: record.eorderType,
        //   flags: record.flags,
        //   orders: record.orders,
        //   fail: record.fail,
        //   declareAt: record.declareAt,
        // };
        let bOrder = JSON.parse(JSON.stringify(record));
        Vue.set(bOrder, "isMergeLine", true);
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.orders.forEach((item) => {
          rs.push(item);
        });
      });
      return rs;
    },
    buildMergeCells(records) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < records.length; i++) {
        mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 8 });
        rowIdx = rowIdx + records[i].orders.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMergeLine
        ? "light-blue-bg"
        : this.rowBgColor({ row: row, rowIndex: rowIndex });
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (row.isMergeLine) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>